import React from 'react';

import { Path } from '@edx/graphql/generated';
import PathPage from '@edx/pages/paths/[slug]';

export { getStaticPaths, getStaticProps } from '@edx/pages/paths/[slug]';

type Props = {
  paths: Path[];
  path: Path;
};

const ItinerarioPage: React.FC<Props> = ({ path, paths }) => <PathPage path={path} paths={paths} />;

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
ItinerarioPage.navBar = { position: 'absolute', variant: 'transparent' };

export default ItinerarioPage;
